import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { History } from "lucide-react";

const LABELS = { base_salary: "Fixlohn", hourly_rate: "Stundenansatz", pensum_percent: "Pensum", children_count: "Anzahl Kinder",
  child_allowance_per_child: "Zulage/Kind", children: "Kinder", bvg_fixed_amount: "BVG fix", qst_rate: "QST-Satz", qst_fixed_amount_override: "QST-Override",
  iban: "IBAN", employment_type: "Anstellungsart", entry_date: "Eintritt", exit_date: "Austritt", bonus_model: "Bonusmodell" };
const fmt = (v) => (v === null || v === undefined ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));
const fmtDate = (iso) => (iso ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}.${iso.slice(0, 4)}` : "—");

/** Iter310 (F2-67): Stammdaten-Historie – alt / neu / gültig ab / Benutzer. */
export function EmployeeHistory({ companyId, employeeId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!companyId || !employeeId) return;
    apiClient.get(`/companies/${companyId}/employees/${employeeId}/history`).then((r) => setItems(r.data || [])).catch(() => setItems([]));
  }, [companyId, employeeId]);
  if (items.length === 0) return null;
  return (
    <div className="rounded-md border border-slate-200 p-3" data-testid="employee-history">
      <div className="flex items-center gap-2 text-sm font-medium mb-2"><History className="h-4 w-4 text-slate-500" />Änderungshistorie (lohnrelevante Stammdaten)</div>
      <ul className="space-y-1 text-xs text-slate-600 max-h-40 overflow-auto">
        {items.map((h) => h.changes.map((c, i) => (
          <li key={h.id + i} data-testid={`employee-history-row-${h.id}-${i}`}>
            <span className="font-medium text-slate-800">{LABELS[c.field] || c.field}</span>: {fmt(c.old)} → <span className="font-medium">{fmt(c.new)}</span>
            <span className="text-slate-400"> · gültig ab {fmtDate(h.valid_from)} · {h.changed_by} · {fmtDate(h.changed_at)}</span>
          </li>
        )))}
      </ul>
    </div>
  );
}
